export enum EResultScoreDateRange {
  Today = "today",
  LastWeek = "lastWeek",
  LastMonth = "lastMonth",
  AllTime = "allTime",
}
